const Exercises = [
  {
    id: 1,
    title: "3d sketches without color",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    image: "/images/3d sketches without color.jpg",
    price: 45,
  },
  {
    id: 2,
    title: "3d sketches with color",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    image: "/images/3d sketches with color.jpg",
    price: 60,
  },
  {
    id: 3,
    title: "2d sketches without color",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    image: "/images/2d sketches.jpg",
    price: 25,
  },
  {
    id: 4,
    title: "2d sketches with color",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    image: "/images/2d sketches with color.jpg",
    price: 35,
  },
];

export default Exercises;
